module.exports = __webpack_public_path__ + "static/media/logo.f14b1d2f.svg";